import './index.scss'

import Icon from 'assets/download.svg?react'
import clsx from 'clsx'
import React from 'react'
import { ClassName } from 'types/props'

import { getAccessToken } from '@/api'
import { downloadCSVFile } from '@/utilities/download'

interface OnClickProps extends ClassName {
  onClick: () => void
}
interface HrefProps extends ClassName {
  href: string
}

type Props = OnClickProps | HrefProps

export const onDownloadLinkClick = async ({
  body = null,
  filename,
  method = 'GET',
  url
}: {
  body?: any
  filename?: string
  method?: string
  url: string
}) => {
  const accessToken = await getAccessToken()

  const headers: HeadersInit = {
    Accept: 'application/octet-stream',
    'Content-Type': 'application/json',
    ...(accessToken && { Authorization: `Bearer ${accessToken}` })
  }

  const response = await fetch(url, {
    method,
    headers,
    body: method === 'POST' ? JSON.stringify(body) : null
  })

  if (!response.ok) {
    throw new Error('Failed to download file')
  }

  const contentType = response.headers.get('Content-Type')
  const blob = await response.blob()

  if (!filename) {
    const contentDisposition = response.headers.get('Content-Disposition')
    if (contentDisposition && contentDisposition.includes('filename=')) {
      filename = contentDisposition.split('filename=')[1].split(';')[0].trim().replace(/['"]/g, '')
    } else {
      filename = url.split('/').pop() || 'downloaded_file'
    }
  }
  filename = filename.replace(/[^a-z0-9_.-]/gi, '_')

  if (contentType === 'text/csv') {
    downloadCSVFile(filename, blob)
  } else {
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
  }
}

export const DownloadLink: React.FC<Props> = props => {
  if ('href' in props) {
    const { children, className, href } = props
    return (
      <a download className={clsx('download-link', className)} href={href}>
        <Icon />
        <span>{children}</span>
      </a>
    )
  }
  if ('onClick' in props) {
    const { children, className, onClick } = props
    return (
      <button className={clsx('download-link', className)} type="button" onClick={onClick}>
        <Icon />
        <span>{children}</span>
      </button>
    )
  }
}
